module.exports = __webpack_public_path__ + "filter.8b6c5a76100d22e309a3684d44f0be87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filter.svg
// module id = 1139
// module chunks = 0